module.exports = __webpack_public_path__ + "static/media/card_price.b560f157.png";